import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const MusicSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.musicsections.editSection'}>
      <Edit>
        <ProductSectionForm
          entity="musics"
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default MusicSectionEdit
